import React from "react"

const NightLightRain: React.FC<{ styling?: any }> = ({ styling }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 30 30"
      css={[styling]}
      fill="#fff"
    >
      <path
        d="M4.22,16.89c0,1.33,0.46,2.48,1.39,3.44s2.06,1.47,3.41,1.53c0.11,0,0.17-0.06,0.17-0.17v-1.37c0-0.13-0.06-0.19-0.17-0.19
	c-0.88-0.06-1.61-0.41-2.21-1.03c-0.6-0.62-0.9-1.36-0.9-2.21c0-0.84,0.28-1.58,0.85-2.2c0.57-0.62,1.27-0.97,2.11-1.04l0.52-0.07
	c0.12,0,0.19-0.06,0.19-0.19l0.07-0.5c0.11-1.08,0.57-1.99,1.38-2.72s1.77-1.1,2.87-1.1c1.09,0,2.05,0.36,2.86,1.09
	c0.81,0.73,1.28,1.64,1.4,2.72l0.06,0.57c0,0.12,0.06,0.18,0.19,0.18h1.6c0.91,0,1.68,0.32,2.32,0.95c0.64,0.63,0.97,1.4,0.97,2.28
	c0,0.85-0.3,1.59-0.89,2.21c-0.59,0.62-1.33,0.97-2.19,1.03c-0.14,0-0.21,0.06-0.21,0.19v1.37c0,0.11,0.07,0.17,0.21,0.17
	c1.33-0.04,2.46-0.55,3.39-1.51c0.93-0.97,1.39-2.12,1.39-3.45c0-0.74-0.14-1.41-0.43-2.01c0.79-0.96,1.18-2.07,1.18-3.36
	c0-0.94-0.24-1.82-0.71-2.63s-1.11-1.45-1.92-1.92c-0.81-0.47-1.68-0.71-2.62-0.71c-1.52,0-2.83,0.58-3.93,1.75
	C15.74,7.61,14.85,7.4,13.9,7.4c-1.41,0-2.67,0.44-3.76,1.31s-1.8,2-2.1,3.37c-1.11,0.26-2.02,0.84-2.74,1.74
	C4.58,14.71,4.22,15.74,4.22,16.89z M10.15,17.77c0,0.38,0.14,0.7,0.43,0.98c0.28,0.27,0.62,0.41,1.02,0.41s0.73-0.13,1-0.4
	c0.27-0.27,0.41-0.6,0.41-0.98c0-0.26-0.12-0.6-0.35-1.02c-0.23-0.42-0.45-0.76-0.66-1c-0.02-0.02-0.08-0.09-0.18-0.2
	c-0.1-0.11-0.17-0.19-0.21-0.24l-0.36,0.4c-0.28,0.3-0.53,0.65-0.75,1.05C10.27,17.17,10.15,17.51,10.15,17.77z M13.14,21.76
	c0,0.63,0.23,1.18,0.69,1.64c0.46,0.46,1.01,0.69,1.65,0.69c0.64,0,1.2-0.23,1.66-0.69c0.46-0.46,0.69-1.01,0.69-1.64
	c0-0.27-0.08-0.59-0.23-0.97c-0.16-0.38-0.34-0.72-0.56-1.04c-0.46-0.59-0.89-1.09-1.29-1.49c-0.06-0.04-0.14-0.13-0.26-0.24
	L14.9,18.6c-0.44,0.42-0.85,0.95-1.21,1.56C13.32,20.78,13.14,21.31,13.14,21.76z M14.62,15.06c0,0.27,0.09,0.49,0.28,0.67
	s0.43,0.27,0.71,0.27c0.26,0,0.48-0.09,0.66-0.27s0.27-0.4,0.27-0.67c0-0.41-0.31-0.94-0.93-1.61l-0.25,0.26
	c-0.19,0.2-0.36,0.43-0.51,0.7C14.69,14.67,14.62,14.89,14.62,15.06z M18.01,9.02c0.67-0.66,1.5-0.99,2.48-0.99
	c0.98,0,1.81,0.34,2.49,1.02s1.03,1.51,1.03,2.48c0,0.63-0.17,1.25-0.51,1.85c-1-0.96-2.17-1.44-3.51-1.44H19.7
	C19.42,10.76,18.85,9.79,18.01,9.02z"
      />
    </svg>
  )
}

export default NightLightRain
